/**
 * Flash-E - Technical Interview Flashcards
 * Copyright (c) 2025 Steve Crittenden
 * Licensed under AGPL-3.0
 *
 * https://github.com/critter/flash-e
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, HashRouter } from 'react-router-dom';
import App from './App';
import './index.css';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Use HashRouter for file:// protocol (Electron), BrowserRouter for http:// (dev server)
const Router = window.location.protocol === 'file:' ? HashRouter : BrowserRouter;

root.render(
  <React.StrictMode>
    <Router>
      <App />
    </Router>
  </React.StrictMode>
);

// Register service worker only for PWA (not Electron)
// Check if running in browser (not Electron)
if ('serviceWorker' in navigator && !window.electronAPI) {
  window.addEventListener('load', () => {
    // Use PUBLIC_URL environment variable for correct path resolution
    const swPath = `${process.env.PUBLIC_URL}/service-worker.js`;
    navigator.serviceWorker
      .register(swPath)
      .then((registration) => {
        console.log('[PWA] Service Worker registered successfully:', registration.scope);
        console.log('[PWA] Service Worker path:', swPath);

        // Check for updates periodically
        setInterval(() => {
          registration.update();
        }, 60000); // Check every minute
      })
      .catch((error) => {
        console.error('[PWA] Service Worker registration failed:', error);
        console.error('[PWA] Attempted path:', swPath);
      });
  });
} else if (window.electronAPI) {
  console.log('[Electron] Running in Electron, service worker not registered');
} else {
  console.log('[Browser] Service workers not supported in this browser');
}